/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Col, Row, Tooltip } from 'antd';
import { Block } from 'components/block';
import { useCurrentEditingBlock } from 'components/block/utils';
import { EditButton } from 'components/buttons/edit-button';
import { Certificate } from 'components/certificate';
import { CertificateEmptyIcon, InfoCircleIcon } from 'components/icons';
import { useEmployee } from 'hooks';
import { editCertificatesModal } from 'user/modals/edit-certificates-modal';
import styles from './styles.less';

export const CertificatesBlock: FC = () => {
  const { t } = useTranslation('translation');

  const { employee, error } = useEmployee();
  const certificates = employee?.certificates?.slice().reverse() || [];

  const children =
    employee?.certificates?.length === 0 ? (
      <CertificateEmptyIcon className={styles['certificate-empty-icon']} />
    ) : (
      <Row gutter={[16, 16]}>
        {certificates.map((certificate, i) => (
          <Col
            span={24}
            sm={{ span: 12 }}
            lg={{ span: 8 }}
            key={`${certificate.certificate || 'cert'}-${i}`}
          >
            <Certificate {...certificate} />
          </Col>
        ))}
      </Row>
    );

  const { currentEditingBlock } = useCurrentEditingBlock();

  const buttons = [
    currentEditingBlock ? (
      <Tooltip
        key="tooltip-2"
        placement="bottom"
        title="Complete editing in another section to modify this"
      >
        <div>
          <EditButton disabled={true} />
        </div>
      </Tooltip>
    ) : certificates.length > 0 ? (
      <EditButton key="edit-button" onClick={editCertificatesModal} />
    ) : null,
  ];

  const infoCircle = (
    <Tooltip title="This section shows the certificates from EMS. Upload a scan of the certificate and give it a name.">
      <InfoCircleIcon />
    </Tooltip>
  );

  return (
    <Block title={t('Certificates')} extra={buttons} subTitle={infoCircle}>
      {error || !employee ? (
        <Alert type="error" message={error?.message} showIcon />
      ) : (
        children
      )}
    </Block>
  );
};
